/* eslint-disable no-unused-vars */
import styles from "../css/app.css";
/* eslint-enable no-unused-vars */

import DatePicker from "v-calendar/lib/components/date-picker.umd";

const main = async () => {
  // Async load dependencies
  const { default: Vue } = await import(/* webpackChunkName: "vue" */ "vue");

  const { default: axios } = await import(
    /* webpackChunkName: "axios" */ "axios"
  );

  return {
    Vue,
    axios
  };
};

// Execute async function
main().then(components => {
  const { Vue, axios } = components;

  // Add a global instance of axios to Vue
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  Vue.prototype.$axios = axios;

  Vue.component("date-picker", DatePicker);

  /* eslint-disable no-unused-vars */
  const vm = new Vue({
    el: "#app",
    components: {
      UserSettingsForm: () =>
        import(/* webpackChunkName: "UserSettings" */ "#vue/UserSettingsForm.vue"),
      DatePick: () =>
        import(/* webpackChunkName: "DatePick" */ "#vue/DatePick.vue"),
      CraftFilePicker: () =>
        import(/* webpackChunkName: "CraftFilePicker" */ "#vue/CraftFilePicker.vue"),
      ProfilePhotoPicker: () =>
        import(/* webpackChunkName: "ProfilePhotoPicker" */ "#vue/ProfilePhotoPicker.vue"),
      Toggle: () =>
        import(/* webpackChunkName: "Toggle" */ "#vue/Toggle.vue"),
      FavouriteButton: () =>
        import(/* webpackChunkName: "FavouriteButton" */ "#vue/FavouriteButton.vue"),
      BaseDropdown: () =>
        import(/* webpackChunkName: "BaseDropdown" */ "#vue/BaseDropdown.vue"),
      QuoteReview: () =>
        import(/* webpackChunkName: "QuoteReview" */ "#vue/QuoteReview.vue"),
    },
    data() {
      return {
        userMenuOpen: false,
        mobileMenuOpen: false
      };
    },
    mounted() {
      window.app.emit("vue-mounted");
    },
    methods: {
      toggleUserMenu() {
        if (!this.userMenuOpen) {
          this.userMenuOpen = true;
        } else {
          this.userMenuOpen = false;
        }
      },
      toggleMobileMenu() {
        if (!this.mobileMenuOpen) {
          this.mobileMenuOpen = true;
        } else {
          this.mobileMenuOpen = false;
        }
      }
    }
  });
  /* eslint-enable no-unused-vars */
});
